import { Router } from '@angular/router';
import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { LoginComponent } from "src/app/login/login.component";

@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  constructor(private matDialog: MatDialog,private route: Router) {}

  ngOnInit() {}

  openLoginDialog() {
    this.matDialog.open(LoginComponent, {
      position: {
        top: "5%",
        right: "2%",
      },
      width: "20%",
    });
  }
}
